<template>
  <v-container fluid>
    <div v-if="product.id">
      <!-- browser -->
      <h2>
        {{ $tc('product') }} {{ product.name }}
        <v-btn v-if="user.can('update_product')" :to="'/product/update/' + this.$route.params.id" color="warning"
               size="sm">
          <v-icon>mdi-pencil</v-icon>
          {{ $t('edit') }}
        </v-btn>
      </h2>

      <v-card>
        <v-card-text>
          <table>
            <tbody>
            <tr>
              <td class="text-right pr-2">{{ $t('name') }}</td>
              <td v-if="product.name">{{ product.name }}</td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('zone') }}</td>
              <td v-if="product.zone">{{ product.zone }}</td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('default_starting_temperature') }}</td>
              <td v-if="product.start_temp">{{ product.start_temp }} &deg;{{
                  customerContext.tempFormat()
                }}
              </td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('minimum_temperature') }}</td>
              <td v-if="product.min_temp">{{ product.min_temp }} &deg;{{
                  customerContext.tempFormat()
                }}
              </td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('maximum_temperature') }}</td>
              <td v-if="product.max_temp">{{ product.max_temp }} &deg;{{
                  customerContext.tempFormat()
                }}
              </td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('sku') }}</td>
              <td v-if="product.product_detail.sku">{{ product.product_detail.sku }}</td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('case_weight') }}</td>
              <td v-if="product.product_detail.case_weight">{{ product.product_detail.case_weight }}
                {{ product.product_detail.weight_units }}
              </td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('dimensions') }}</td>
              <td v-if="product.product_detail.height">{{ getProductDimensions(product) }}</td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $t('product_configuration') }}</td>
              <td v-if="product.product_detail.product_configuration">{{
                  product.product_detail.product_configuration
                }}
              </td>
              <td v-else class="not-set">{{ $t('not_set') }}</td>
            </tr>
            <tr>
              <td class="text-right pr-2">{{ $tc('customer', 2) }}</td>
              <td>
                <ul>
                  <li v-for="customer in product.customers" :key="customer.id">
                    {{ customer.name }}
                  </li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

export default {
  data () {
    return {
      showErrorDialog: false,
      product: {},
      productId: null
    }
  },
  mixins: [
    CurrentUserMixin
  ],
  methods: {
    getProductDimensions(product) {
      const height = product.product_detail.height || '?'
      const width = product.product_detail.width || '?'
      const depth = product.product_detail.depth || '?'
      const dimensionUnits = product.product_detail.dimension_units || ''
      return height + ' x ' + width + ' x ' + depth + ' ' + dimensionUnits
    }
  },
  mounted () {
    this.$orm('Product')
      .find(this.$route.params.id, {params: {expand: 'customers,product_detail'}})
      .then((product) => {
        if (!product.product_detail) {
          product.product_detail = {}
        }
        this.product = product
      })
      .catch(error => {
        this.handleError(error)
      })
  }
}
</script>

<style>
.product-data .table th,
.product-data .table td {
  border-top: none;
}

ul.customers {
  margin: 0;
  padding: 0;
}

ul.customers li {
  list-style-type: none;
}

.not-set {
  color: #c55;
  font-style: italic;
  white-space: nowrap;
}
</style>
